import { z } from 'zod';

export const getCompetitorTypeSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  deleted: z.boolean(),
});

export const getCompetitorTypesSchema = z.array(getCompetitorTypeSchema);

export type GetCompetitorTypesResponse = z.infer<typeof getCompetitorTypesSchema>;
